import React, { useState, ReactNode, useEffect } from 'react';
import {
  AnimationAppearLeft,
  AnimationAppearRight,
  AnimationFadeIn,
  CursorText,
} from './styles';

export { AnimationAppearLeft, AnimationAppearRight, AnimationFadeIn };

interface IAnimationFadeInDelay {
	delay: number;
	children: ReactNode;
}

export const AnimationDelay: React.FC<IAnimationFadeInDelay> = ({
  delay,
  children,
}: IAnimationFadeInDelay) => {
  const [content, setContent] = useState<ReactNode>(<></>);

  useEffect(() => {
    const element = <AnimationFadeIn duration={delay}>{children}</AnimationFadeIn>
    const timeout = setTimeout(() => setContent(element), delay);
    return () => clearTimeout(timeout);
  }, [children, delay]);

  return <>{content}</>;
};

interface IAnimationText {
	text: string;
}

export const AnimationText: React.FC<IAnimationText> = ({
  text,
}: IAnimationText) => {
  const [textAnime, setTextAnime] = useState<string>('');

  const animationText = (text: string, index: number) => {
    if (index < text.length) {
      setTextAnime(text.slice(0, index + 1));

      setTimeout(() => animationText(text, index + 1), 100);
    }

    return;
  };

  const run = () => animationText(text, 0);

  useEffect(run, [text]);

  return (
    <>
      {textAnime}
      <CursorText />
    </>
  );
};
